import React from 'react';
import styled from 'astroturf/react';

import { MarketingCourse } from '../shared/course_helper';
import SignUpButton from '../shared/SignUpButton';
import CourseCard from './CourseCard';
import LearningPoints from './LearningPoints';
import NewCourses from './NewCourses';
import MarketingPageLayout from './MarketingPageLayout';
import { CarouselProps } from '../shared/Carousel';

export interface Props {
  course: MarketingCourse;
  carousel: CarouselProps;
}

const CourseTitle = styled.h1`
  @import '../shared/mixins.scss';
  @include headingH2();
  @include textPrimary();
  margin: 0;
`;

const CourseSubtitle = styled.h2`
  @import '../shared/mixins.scss';
  @include subheadRegular();
  @include textPrimary();
  margin: 0;
`;

const MarketingPage: React.FunctionComponent<Props> = ({
  course,
  carousel,
}) => {
  const {
    id,
    title,
    description,
    trailer,
    instructor,
    videos,
    videoCount,
    duration,
  } = course;

  return (
    <MarketingPageLayout
      title={<CourseTitle>{title}</CourseTitle>}
      subtitle={
        <CourseSubtitle>Course taught by {instructor.name}</CourseSubtitle>
      }
      courseCard={
        <CourseCard
          courseId={id}
          trailer={trailer}
          playlist={{ videos, videoCount, duration }}
          instructor={instructor}
        />
      }
      courseLearningPoints={<LearningPoints description={description} />}
      newCourses={<NewCourses carousel={carousel} />}
      signUpButton={<SignUpButton />}
    />
  );
};

export default MarketingPage;
